export default __webpack_public_path__ + "static/media/medicine-1.88482389.png";